import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import {
  DepositMethod,
  DepositMethodTextMap,
  DepositMethodUnitMap
} from '@eastcoal/shared/enums/DepositMethod'

import { DepositInputProps } from './interface'
// 保证金不显示【不收取】
const options = mapNumberEnumOptions(DepositMethodTextMap).filter(
  option => option.value !== DepositMethod.NONE
)

const Component = ({ disabled, value = {}, onChange }: DepositInputProps) => {
  const handleSelectChange = (depositMethod: DepositMethod) => {
    onChange?.({
      ...value,
      depositMethod
    })
  }

  const handleInputChange = (depositValue?: number) => {
    onChange?.({
      ...value,
      depositValue
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.depositMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled}
        min={0}
        value={value.depositValue}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange as any}
      />
      {!isNil(value.depositMethod) && (
        <span>{DepositMethodUnitMap[value.depositMethod]}</span>
      )}
    </Space.Compact>
  )
}

export const DepositInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
